<dt-table-layout *dtDataLoad="true; error: hasError()">
  <div header class="cp-filters-form">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Nach Name filtern</mat-label>
      <input matInput type="text" [ngModel]="nameFilter()" (ngModelChange)="nameFilter.set($event)" />
    </mat-form-field>

    <dt-tag-input [allTags]="tagsWithProductivityFlag()" [selectedTagIds]="tagFilter()" (selectedTagIdsChange)="tagFilter.set($event)" i18n
      >Nach Tags filtern</dt-tag-input
    >

    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Namen anzeigen auf</mat-label>

      <mat-select [ngModel]="languageFilter()" (ngModelChange)="languageFilter.set($event)" multiple>
        <mat-option value="de" [disabled]="languageFilter().length === 1 && showGermanNames()" i18n>Deutsch</mat-option>
        <mat-option value="en" [disabled]="languageFilter().length === 1 && showEnglishNames()" i18n>Englisch</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="filler"></div>
    <button mat-raised-button color="primary" (click)="addQuestion()">
      <mat-icon>add</mat-icon>
      <ng-container i18n>Entscheidungsfrage hinzufügen</ng-container>
    </button>
  </div>

  <table
    mat-table
    [dataSource]="displayedQuestions()"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="activeSort().active"
    [matSortDirection]="activeSort().direction"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="nameDe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Deutscher Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.de }}</td>
    </ng-container>
    <ng-container matColumnDef="nameEn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Englischer Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.en }}</td>
    </ng-container>
    <ng-container matColumnDef="countAssigned">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Ausgewählt</th>
      <td mat-cell *matCellDef="let row">{{ row.countAssigned }}</td>
    </ng-container>
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef i18n>Tags</th>
      <td mat-cell *matCellDef="let row">
        <dt-tag-list
          [tagIds]="row.tags"
          [tagsById]="tagsById()"
          [selectedTagIds]="tagFilter()"
          (tagClick)="tagClick($event.id)"
        ></dt-tag-list>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()" (click)="showDetails(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns().length" i18n>Es wurden noch keine Entscheidungsfragen angelegt.</td>
    </tr>
  </table>

  <dt-table-footer [visibleCount]="displayedQuestions().length" [totalCount]="questions().length"></dt-table-footer>
</dt-table-layout>
